<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listadoObras" :items-per-page="20">
      <template v-slot:[`item.clave`]=" { item }">
        <router-link
        :to="{name: 'obra', params: { idObra: item.id }}">
          {{ item.clave }}
        </router-link>
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
        <v-chip :color="item.tipo.color">
          <span>
            {{item.tipo.descripcion}}
          </span>
        </v-chip>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :obra="item"></opciones>
      </template>
      <template v-slot:[`item.proyecto`]="{ item }">
        <v-chip
          v-if="item.proyecto !== null"
          :color="item.proyecto.responsables
        .filter(({ fechaValido }) => fechaValido !== null).length ===
        item.proyecto.responsables.length ? 'success' : 'warning'"
        :to="{ name: 'obraProyectos', params: { idObra: item.id, idProyecto: item.proyecto.id }}">
          <v-icon left>
            mdi-folder-cog
          </v-icon>
          {{ item.proyecto.responsables
          .filter(({ fechaValido }) => fechaValido !== null).length }}
          /
          {{ item.proyecto.responsables.length }}
          <v-icon
            v-if="item.proyecto.responsables
        .filter(({ fechaValido }) => fechaValido !== null).length ===
        item.proyecto.responsables.length"
            right
            small>
            mdi-check
          </v-icon>
        </v-chip>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      <template v-slot:[`item.meta`]="{ item }">
        <cortar-texto
          :texto="item.meta"
          class="d-block">
        </cortar-texto>
        <v-chip
          v-for="(etiquetaItem) in item.etiquetas"
          :key="`etiqueta-${etiquetaItem.idEtiqueta}`"
          :color="etiquetaItem.etiqueta.color"
          :text-color="etiquetaItem.etiqueta.esTextoClaro ? 'white' : 'black'"
          class="ma-1"
          x-small>
          <v-icon left small>mdi-tag</v-icon>
          {{ etiquetaItem.etiqueta.nombre }}
        </v-chip>
      </template>
      <template v-slot:[`item.ObraSolicitud.fechaOficioSolicitud`]="{ item }">
        <v-chip
          :color="item.ObraSolicitud ? 'success' : 'grey lighten-1'"
          :text-color="item.ObraSolicitud ? 'white' : 'black'" class="ma-1" small>
          <v-icon left small>
            {{ item.ObraSolicitud ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline' }}
          </v-icon>
          {{ item.ObraSolicitud
            ? getInternationalDateFormat(item.ObraSolicitud.fechaOficioSolicitud)
            : 'No solicitada' }}
        </v-chip>
      </template>
      <template v-slot:[`item.total`]="{ item }">
        {{ item.total | currency('$', 2) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoPlaneacionDesktop',
  props: {
    listadoObras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
    CortarTexto,
  },
  data() {
    return {
      headers: [
        {
          text: 'Clave',
          align: 'start',
          value: 'clave',
          width: '115',
          sortable: false,
        },
        { text: 'Tipo', value: 'tipo', sortable: false },
        {
          text: 'Objeto', width: '50%', value: 'meta', sortable: false,
        },
        { text: 'Programa', value: 'programa.nombre', sortable: false },
        { text: 'Monto', value: 'total', sortable: false },
        { text: 'Proyecto', value: 'proyecto', sortable: false },
        {
          text: '¿Solicitada?', value: 'ObraSolicitud.fechaOficioSolicitud', sortable: false,
        },
        { text: 'F. Registro', value: 'createdAt', width: '120' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    getInternationalDateFormat(fecha) {
      const date = new Date(fecha);
      return date.toLocaleDateString('en-MX');
    },
  },
};
</script>

<style lang="scss">

</style>
